  <template>
    
            <v-main class="pa-2 pcksgreport" fluid>

            <RangePicker @reloadData="loadData" :range="this.getCurrentMonth()"/>

            <v-subheader>Package Sales by Source</v-subheader>
              <v-data-table
              
                  :headers="headers"
                  :items="totalsbysource"
                  :items-per-page="30"
                  group-by="agentName"
                  >
                  <template v-slot:item.agentName="{ item }">
                      {{item.agentName}} 3
                  </template>
                   
                  <template slot="body.append">
                      <tr class="pink--text">
                        <th v-for="(item, index) in headers" class="title">
{{index > 0 && index % 2 == 0 ? "$" : "" }}{{ index > 0 ? sum(totalsbysource, item.value) : " " }}
                          </th>
                      </tr>
                  </template>
              </v-data-table>
              
            </v-main>
    
</template>
<script>
    import { mapState } from 'vuex'
    import RangePicker from '../components/RangePicker.vue'

    export default {

      components : { RangePicker }, 
      

        mounted () {

          this.$store.dispatch('fetchPckgbySource', {
                range : this.getCurrentMonth()

            })

        },


        computed: {
            ...mapState(['totalsbysource']),



            headers () {

              return this.getHeaders(this.totalsbysource)

            }

        },
        

        methods: {

          loadData(range) {

              this.$store.dispatch('fetchPckgbySource', {
                range : range

            })


          }, 

        
        }
    }
</script>